import { authorizedApiClient } from "../config";

export type TraitHistoryEntry = {
  date?: string;
  snapshot_date?: string;
  value?: any;
  value_numeric?: number;
  count?: number;
};

export type TraitHistoryResponse = {
  trait_name: string;
  entity_type: string;
  record_id: string;
  history: TraitHistoryEntry[];
  total_count?: number;
  percentage_change?: number | null;
  current_value?: any;
};

export type TraitHistoryAllResponse = {
  traits: Record<string, TraitHistoryResponse>;
};

export const getTraitHistory = async ({
  workspace_id,
  entity_type,
  record_id,
  trait_name,
  days,
}: {
  workspace_id: string;
  entity_type: string;
  record_id: string;
  trait_name: string;
  days?: number;
}) =>
  authorizedApiClient.get<TraitHistoryResponse>(
    `/${workspace_id}/trait-history/${entity_type}/${record_id}/${trait_name}`,
    days ? { params: { days } } : undefined
  );

export const getTraitHistoryAll = async ({
  workspace_id,
  entity_type,
  record_id,
  days,
}: {
  workspace_id: string;
  entity_type: string;
  record_id: string;
  days?: number;
}) =>
  authorizedApiClient.get<TraitHistoryAllResponse>(
    `/${workspace_id}/trait-history/${entity_type}/${record_id}`,
    days ? { params: { days } } : undefined
  );
